"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Accordion = ({
  collapsed,
  children,
  title,
  count,
  onClick,
  buttonProps,
  icon,
  render
}) => {
  const [isCollapsed, setIsCollapsed] = _react.default.useState(collapsed);

  const setIsCollapsedWrapper = (e, state) => {
    e.preventDefault();
    setIsCollapsed(!isCollapsed);
    if (typeof onClick === 'function') onClick(e, state);
  };

  return /*#__PURE__*/_react.default.createElement(_styles.StyledAccordion, {
    className: (0, _classnames.default)({
      'with-render': render,
      'with-icon': icon
    })
  }, /*#__PURE__*/_react.default.createElement(_styles.Row, {
    className: "collapse-card-header"
  }, /*#__PURE__*/_react.default.createElement(_styles.Col, {
    className: "right",
    onClick: e => setIsCollapsedWrapper(e, isCollapsed)
  }, /*#__PURE__*/_react.default.createElement(_styles.Row, {
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_styles.Row, null, icon && /*#__PURE__*/_react.default.createElement(_styles.Col, {
    className: "card-icon"
  }, /*#__PURE__*/_react.default.createElement(_index.Icon, {
    iconName: icon,
    size: 16,
    className: isCollapsed ? 'icon' : 'icon rotate'
  })), /*#__PURE__*/_react.default.createElement(_styles.Col, {
    className: "card-title"
  }, title, " ", count && /*#__PURE__*/_react.default.createElement("span", null, "(", count, ")"))), render && /*#__PURE__*/_react.default.createElement(_styles.Row, {
    className: "renderer"
  }, render()))), buttonProps && /*#__PURE__*/_react.default.createElement(_styles.Col, {
    className: "left"
  }, /*#__PURE__*/_react.default.createElement(_index.Button, _extends({
    isPrimary: false,
    size: "small"
  }, buttonProps)))), /*#__PURE__*/_react.default.createElement("div", {
    className: `collapse-content ${isCollapsed ? 'collapsed' : 'expanded'}`,
    "aria-expanded": isCollapsed
  }, children && children));
};

exports.Accordion = Accordion;
Accordion.defaultProps = {
  collapsed: true
};
Accordion.propTypes = {
  collapsed: _propTypes.default.bool,
  children: _propTypes.default.element,
  title: _propTypes.default.string,
  count: _propTypes.default.number,
  onClick: _propTypes.default.func,
  buttonProps: _propTypes.default.object,
  icon: _propTypes.default.string,

  /** render: is used to add additional content below accordion title eg: Pill */
  render: _propTypes.default.func
};